/* 🤖 this file was generated by svg-to-ts */
export const matIconLocationCity: {
  name: 'location-city';
  data: string;
} = {
  name: 'location-city',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"/></svg>`
};
